import { render, staticRenderFns } from "./BaseSubRouteContainer.vue?vue&type=template&id=1f601b18"
import script from "./BaseSubRouteContainer.vue?vue&type=script&lang=js"
export * from "./BaseSubRouteContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports